export default "__VITE_PUBLIC_ASSET__d387a7e6__"